import { useSyncExternalStore } from 'react';
import { activityMapHomeEnabled } from './home-variant';
import { ACTIVITY_MAP_HOME_SPEC, toggleOverride } from './dev-feature-toggles';

// The category pages' redesign (Figma 21055:246799) ships with the activity-map home: the home draws the
// categories, and each one's standalone page follows the same release so the two never disagree. Off, every
// page renders its `*.legacy` body — the design that shipped before.

let decided: boolean | undefined;
const listeners = new Set<() => void>();

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  if (decided === undefined) {
    void activityMapHomeEnabled().then((on) => {
      decided = on;
      listeners.forEach((notify) => notify());
    });
  }
  return () => {
    listeners.delete(listener);
  };
}

function snapshot(): boolean | undefined {
  const forced = toggleOverride(ACTIVITY_MAP_HOME_SPEC);
  return forced === undefined ? decided : forced === 'true';
}

// The server cannot know the answer, so hydration renders "unresolved" and the client then moves to its own
// answer. A mount after the gate has answered gets it on its first render.
const serverSnapshot = (): undefined => undefined;

/** `on` is the release; `resolved` is false only while the gate's first answer is still in flight. */
export function useCategoryRedesign(): { on: boolean; resolved: boolean } {
  const value = useSyncExternalStore(subscribe, snapshot, serverSnapshot);
  return { on: value === true, resolved: value !== undefined };
}
